import { render, staticRenderFns } from "./ProjectSettingAccountingProduct.vue?vue&type=template&id=2ea7525f"
import script from "./ProjectSettingAccountingProduct.vue?vue&type=script&lang=js"
export * from "./ProjectSettingAccountingProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports